import {Button, FontIcon} from "@/app/_components";
import styles from './list.module.css';
import {DriveUtil} from "@/Master/DriveUtil";
import Load from "@/app/_components/Load/Load";
import React from "react";
import Util from "@/Master/Util";
import {RecordFailState, RedeemRecordState} from "@/Core/Redeem/redeemEnum";
import {RedeemRecordInfo} from "@/Core/Redeem/redeemEntity";
import {RedeemManager} from "@/Core/Redeem/RedeemManager";
import BigTips from "@/Master/BigTips";

type RedeemListProps = {
    listData: RedeemRecordInfo[];
}

const status = {
    reCheck: '#FFA800',
    success: '#29D181',
    fail: '#FE414E',
}

const btnStyles = {
    color: '#fff',
    width: '1.7rem',
    height: '0.6rem',
}

const List: React.FC<RedeemListProps> = (props) => {

    const {listData} = props;

    const isDataOk = () => {
        return listData && listData.length> 0;
    }

    const updateState = (item: RedeemRecordInfo) => {
        let content;
        switch (item.state) {
            case RedeemRecordState.Successful:
                content = <>
                    <div style={{color: status.success}}>Successful</div>
                    <Button color="#33D24A" style={btnStyles} onClick={() => {
                        //TODO UI逻辑订单成功信息页面
                    }}>Check</Button>
                </>
                break;
            case RedeemRecordState.ReviewCanCancel:
                content = <>
                    <div style={{color: status.reCheck}}>Under review</div>
                    <Button color="#0090FF" style={btnStyles} onClick={() => {
                        //TODO UI逻辑订单取消信息页面
                        RedeemManager.Instance.CancelRedeem(item.id, finish => {
                            BigTips.showMsg(finish ? 'Cancel successfully.' : 'Cancel Failed.')
                        })
                    }}>Cancel</Button>
                </>
                break;
            case RedeemRecordState.ReviewNoCancel:
                content = <>
                    <div style={{color: status.reCheck}}>Under review</div>
                </>
                break;
            case RedeemRecordState.Process:
                content = <>
                    <div style={{color: status.reCheck}}>Processing</div>
                </>
                break;
            default:
                content = <>
                    <div style={{color: status.fail}}>Fail</div>
                    {/*<Button color={'#33D24A'} style={btnStyles}>Check</Button>*/}
                </>
        }
        return content;
    }


    return (
        <section className={styles.wrapper}>
            <section className={styles.head}>
                <section className={`${styles.col}`}>Redemption</section>
                <section className={`${styles.col}`}>Account</section>
                <section className={`${styles.col}`}>Status</section>
            </section>

            {isDataOk() ? '':<Load/>}
            {
                isDataOk() && listData.map((item, index) => (
                    <section className={styles.row} key={index}>
                        <section className={`${styles.col}`}>
                            <img
                                className={styles.icon_payment}
                                src="/img/redeem/img_y_paypal.png"
                                alt=""
                            />
                            <span style={{
                                fontSize: '.5rem',
                                fontWeight: 'bold'
                            }}>{DriveUtil.ToDollarString(item.dollar)}</span>
                        </section>
                        <section className={`${styles.col}`}>
                            <div style={{marginBottom: '.1rem'}}>{item.account}</div>
                            <div>{item.dateTime}</div>
                        </section>
                        <section className={`${styles.col} ${styles.waiting}`}>
                            {updateState(item)}
                        </section>
                    </section>
                ))
            }

            {/*<section className={styles.row}>*/}
            {/*    <section className={`${styles.col}`}>*/}
            {/*        <img className={styles.icon_payment} src="/img/ico_scs.png" alt=""/>*/}
            {/*        <span style={{fontSize: '.5rem', fontWeight: 'bold'}}>$499.99</span>*/}
            {/*    </section>*/}
            {/*    <section className={`${styles.col}`}>*/}
            {/*        <div>kimdz@yahoo.com</div>*/}
            {/*        <div>2024/09/10 14:00:00</div>*/}
            {/*    </section>*/}
            {/*    <section className={`${styles.col} ${styles.waiting}`}>*/}
            {/*        /!*<FontIcon item="s-success" style={{fontSize: '.5rem'}}/>*!/*/}
            {/*        <div style={{color: status.reCheck}}>Under review</div>*/}
            {/*        <Button*/}
            {/*            color="#0090FF"*/}
            {/*            style={{*/}
            {/*                color: '#fff',*/}
            {/*                width: '1.7rem',*/}
            {/*                height: '0.6rem',*/}
            {/*            }}*/}
            {/*        >Cancel</Button>*/}
            {/*    </section>*/}
            {/*</section>*/}

            {/*<section className={styles.row}>*/}
            {/*    <section className={`${styles.col}`}>*/}
            {/*        <img className={styles.icon_payment} src="/img/ico_scs.png" alt=""/>*/}
            {/*        <span style={{fontSize: '.5rem', fontWeight: 'bold'}}>$499.99</span>*/}
            {/*    </section>*/}
            {/*    <section className={`${styles.col}`}>*/}
            {/*        <div>kimdz@yahoo.com</div>*/}
            {/*        <div>2024/09/10 14:00:00</div>*/}
            {/*    </section>*/}
            {/*    <section className={`${styles.col} ${styles.waiting}`}>*/}
            {/*        /!*<FontIcon item="s-success" style={{fontSize: '.5rem'}}/>*!/*/}
            {/*        <div style={{color: status.success}}>Successful</div>*/}
            {/*        <Button*/}
            {/*            color="#33D24A"*/}
            {/*            style={{*/}
            {/*                color: '#fff',*/}
            {/*                width: '1.7rem',*/}
            {/*                height: '0.6rem',*/}
            {/*            }}*/}
            {/*        >Cancel</Button>*/}
            {/*    </section>*/}
            {/*</section>*/}

            {/*<section className={styles.row}>*/}
            {/*    <section className={`${styles.col}`}>*/}
            {/*        <img className={styles.icon_payment} src="/img/ico_scs.png" alt=""/>*/}
            {/*        <span style={{fontSize: '.5rem', fontWeight: 'bold'}}>$499.99</span>*/}
            {/*    </section>*/}
            {/*    <section className={`${styles.col}`}>*/}
            {/*        <div>kimdz@yahoo.com</div>*/}
            {/*        <div>2024/09/10 14:00:00</div>*/}
            {/*    </section>*/}
            {/*    <section className={`${styles.col} ${styles.waiting}`}>*/}
            {/*        /!*<FontIcon item="s-success" style={{fontSize: '.5rem'}}/>*!/*/}
            {/*        <div style={{color: status.fail}}>Fail</div>*/}
            {/*        <Button*/}
            {/*            color="#33D24A"*/}
            {/*            style={{*/}
            {/*                color: '#fff',*/}
            {/*                width: '1.7rem',*/}
            {/*                height: '0.6rem',*/}
            {/*            }}*/}
            {/*        >Cancel</Button>*/}
            {/*    </section>*/}
            {/*</section>*/}
        </section>
    )
}

export default List;